import * as ax from "../instrance";
import config from "../../../config/config.js";
var URL = config.apiUrl;
// var tymhUrl = config.tymhUrl;

// 获取值
export const getKey = params => {
  return ax.pJson(URL + "/cjrh/redis/getKey", params);
};

// 设置值
export const setKey = params => {
  return ax.pJson(URL + "/cjrh/redis/setKey", params);
};

// 设置过期时间
export const setKeyExpire = params => {
  return ax.pJson(URL + "/cjrh/redis/setKeyExpire", params);
};

// mwcz-xyoaxt 获取用户信息
export const getUserInfoByUserId = params => {
  return ax.pJson(URL + "/welink/userlogin/getUserInfoByUserId", params);
};


// // 获取用户菜单
// export const getMenuToUser = params => {
//   return ax.pJson( "http://211.80.233.107:8066/tymh/interface/getMenuToUser.do", params);
// };

// // 获取用户信息
// export const getUserInfoByCount = params => {
//   return ax.pJson( "http://211.80.233.107:8066/tymh/interface/getUserInfoByCount.do", params);
// };

// // 获取用户菜单
// export const getMenuToUser = params => {
//   return ax.pJson( "http://59.56.73.177:18003/mwczxy/interface/getMenuToUser.do", params);
// };

// // 获取用户信息
// export const getUserInfoByCount = params => {
//   return ax.pJson( "http://59.56.73.177:18003/mwczxy/interface/getUserInfoByCount.do", params);
// };

// // 获取用户菜单
// export const getMenuToUser = params => {
//   return ax.pJson( "https://appzb.fjcpc.edu.cn/mwcztymh/interface/getMenuToUser.do", params);
// };

// // 获取用户信息
// export const getUserInfoByCount = params => {
//   return ax.pJson( "https://appzb.fjcpc.edu.cn/mwcztymh/interface/getUserInfoByCount.do", params);
// };


// WEBPACK FOOTER //
// ./src/api/loginApi/loginAx.js